// extracted by mini-css-extract-plugin
export default {"external":"aDRlf6","attention":"bDRlf6","timesWrapper":"cDRlf6","error":"dDRlf6","badge":"eDRlf6"};